module.exports = __webpack_public_path__ + "media/images/team_member/member_6-fd1e57f052b57daf891277c32138f4a8.jpg";